import Vue from "vue";
import AppEditor from "~/components/AppEditor";
import router from "~/router";

export default (editor, opts = {}) => {
    const commands = editor.Commands;
    const sm = editor.StorageManager;
    const md = editor.Modal;

    commands.add("open-step-modal-vue", {
        run: async function (editor, sender, params) {
            sender && sender.set("active", 0);

            let container = document.createElement("div");
            container.setAttribute("id", "vue-app");

            md.setTitle("Step settings").setContent(container).open();

            new Vue({
                ...AppEditor,
                element: "ModalStep",
                editor,
                router,
                opts,
            }).$mount("#vue-app");

            editor.once("modal:close", () => {
                sm.setAutosave(true);
            });
        },
    });
};
